import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Typography,
  Chip,
  Collapse,
  Divider,
  IconButton,
  InputBase,
} from "@material-ui/core";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import RemoveRoundedIcon from "@material-ui/icons/RemoveRounded";
import { ChevronDown } from "react-feather";
function filterBySpecialties(data, selectedSpecialties) {
  const selectedIds = new Set(selectedSpecialties.map((s) => s._id));
  return data.filter((item) =>
    item.specialties.some((s) => selectedIds.has(s._id))
  );
}
export default function AssignList({
  assignment,
  changeAssignment,
  productsSelected,
  doctorsSelected,
}) {
  const { authState } = useContext(AuthContext);
  const classes = useStyles();
  const [openDetails, setOpenDetails] = useState("");
  // useEffect(() => {
  //   console.log({ assignment, productsSelected, doctorsSelected });
  // }, [assignment]);

  return (
    <>
      <Box component={"section"} className={classes.container_content}>
        <List className={classes.samples_list}>
          {Object.values(doctorsSelected)?.map((d) => {
            const { doctorId, name, rut, specialties } = d;
            const availableSamples = filterBySpecialties(
              Object.values(productsSelected),
              specialties
            );
            // console.log(availableSamples);

            return (
              <ListItem
                key={doctorId}
                className={classes.doctor_list_item}
                component={"li"}
              >
                <ListItemText
                  onClick={() => {
                    setOpenDetails(doctorId);
                  }}
                  primary={
                    <Box
                      component={"span"}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Box
                        component={"span"}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          wordBreak: "break-all",
                          width: "100%",
                          flex: 1,
                        }}
                      >
                        <Typography component={"span"}>{name}</Typography>
                        <Typography
                          variant="caption"
                          style={{ marginTop: "-4px" }}
                        >{`${rut}`}</Typography>
                      </Box>
                      <Box
                        component={"span"}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <IconButton>
                          <ChevronDown />
                        </IconButton>
                      </Box>
                    </Box>
                  }
                  secondary={
                    <Box
                      style={{ display: "flex", flexWrap: "wrap" }}
                      component={"span"}
                    >
                      {specialties.map((s) => (
                        <Chip
                          component={"span"}
                          size="small"
                          variant="outlined"
                          color="primary"
                          style={{ fontSize: "0.8rem" }}
                          label={s.name}
                          key={`${doctorId}-${s._id}`}
                        />
                      ))}
                    </Box>
                  }
                />

                <Collapse
                  in={openDetails === doctorId}
                  style={{ width: "100%" }}
                >
                  {!availableSamples.length ? (
                    <Box
                      style={{
                        display: "flex",
                        padding: "12px 8px",
                        backgroundColor: "#ffa50038",
                        width: "100%",
                      }}
                    >
                      <Typography>
                        No ha seleccionado muestras compatibles con este medico.
                      </Typography>
                    </Box>
                  ) : (
                    <List>
                      <Divider />
                      {availableSamples.map((p) => {
                        const {
                          productId,
                          name,
                          molecule,
                          concentration,
                          specialties,
                        } = p;

                        return (
                          <ListItem
                            key={`${doctorId}-${productId}`}
                            className={classes.samples_list_item}
                          >
                            <ListItemText
                              style={{
                                marginBottom: 4,
                                marginTop: 4,
                                width: "100%",
                              }}
                              primary={
                                <Box
                                  component={"span"}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    wordBreak: "break-all",
                                  }}
                                >
                                  <Typography component={"span"}>
                                    {name}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    style={{ marginTop: "-4px" }}
                                  >{`${molecule} - ${concentration}`}</Typography>
                                </Box>
                              }
                              secondary={
                                <Box
                                  style={{ display: "flex", flexWrap: "wrap" }}
                                  component={"span"}
                                >
                                  {specialties.map((s) => (
                                    <Chip
                                      component={"span"}
                                      size="small"
                                      variant="outlined"
                                      style={{ fontSize: "0.8rem" }}
                                      label={s.name}
                                      key={`${doctorId}-${productId}-${s._id}`}
                                    />
                                  ))}
                                </Box>
                              }
                            />
                            <NumericInput
                              initialValue={
                                assignment[doctorId]?.[productId]?.qty ?? 0
                              }
                              handleValueChange={(v) => {
                                changeAssignment({
                                  doctorId,
                                  productId,
                                  qty: v,
                                });
                              }}
                            />
                          </ListItem>
                        );
                      })}
                    </List>
                  )}
                </Collapse>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  container_content: {
    flex: 1,
    maxHeight: "70vh",
    overflowY: "auto",
  },
  doctor_list_item: {
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[400]}`,
    flexDirection: "column",
    alignItems: "start",
    marginTop: 12,
    backgroundColor: `hsl(from ${theme.palette.primary.light} h s calc(l + 54))`,
    "& >.MuiListItemText-multiline": {
      marginBottom: 4,
      marginTop: 4,
      width: "100%",
      "&:hover, &:active": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  samples_list_item: {
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[400]}`,
    marginTop: 12,
  },
  input: {
    display: "flex",
    maxWidth: 90,
    borderRadius: 8,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.common.white,
    height: 35,
    "& input": {
      textAlign: "center",
    },
    "& >button": {
      backgroundColor: theme.palette.grey[200],
      borderRadius: "inherit",
    },
  },
}));

function NumericInput({ handleValueChange, initialValue }) {
  const [value, setValue] = useState(`${initialValue}`);
  const classes = useInputStyles();

  useEffect(() => {
    handleValueChange(value || 0);
  }, [value]);
  const handleChange = (e) => {
    const val = e.target.value;
    if (val === "" || /^[0-9]+$/.test(val)) {
      setValue(val);
    }
  };

  const increase = () => {
    setValue((prev) => {
      const num = parseInt(prev || "0", 10);
      return String(num + 1);
    });
  };

  const decrease = () => {
    setValue((prev) => {
      const num = parseInt(prev || "0", 10);
      return String(num - 1 < 0 ? 0 : num - 1);
    });
  };
  return (
    <Box className={classes.input}>
      <IconButton
        size="small"
        style={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
        onClick={decrease}
      >
        <RemoveRoundedIcon />
      </IconButton>
      <InputBase type="text" value={value} onChange={handleChange} />
      <IconButton
        size="small"
        style={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
        onClick={increase}
      >
        <AddRoundedIcon />
      </IconButton>
    </Box>
  );
}
const useInputStyles = makeStyles((theme) => ({
  input: {
    display: "flex",
    maxWidth: 90,
    borderRadius: 8,
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.common.white,
    height: 35,
    "& input": {
      textAlign: "center",
    },
    "& >button": {
      backgroundColor: theme.palette.grey[200],
      borderRadius: "inherit",
    },
  },
}));
